import { gql } from '@apollo/client';
import config from '../../config';

const userIndex = config.algolia.algolia_prefix + 'users';
const typeName = config.algolia.algolia_prefix + 'users';

export const SEARCH_STYLIST = gql`
query LocationsQuery ($query : String!, $filters: String!, $hit : Number!, $page : Number!, $facets: [String]!) {
  locationsInRadius @algolia(__typename: ${typeName}, index: ${userIndex}, filters: $filters, hitsPerPage: $hit, query: $query, page: $page, facets: $facets) {
      hits
      nbHits
      facets
      page
      nbPages
  }
}
`;
